import { graphHooks } from '@tunasong/graph-lib/react'
import { logger, shortUuid } from '@tunasong/models'
import { useChat } from '@tunasong/plugin-chat/ui'
import type { TunaEditor } from '@tunasong/plugin-lib'
import { Transforms } from '@tunasong/plugin-lib'
import type { Chat, CoreElement, Persisted } from '@tunasong/schemas'
import { ReactEditor } from 'slate-react'

/** Handle Comments for an Element in an Editor. Will manage child Chat entity. */
export const useCommentsChat = (editor: TunaEditor, element?: CoreElement | null) => {
  const { create: createChat } = useChat<Persisted<Chat>>({ element: null })

  const hasChat = element?.comments
  const loadChatId = hasChat ? element?.id : undefined
  const { entities: chats, isLoading: chatLoading } = graphHooks.useEntityChildren<Chat>({
    parentId: loadChatId,
    filter: 'chat',
  })

  if (chats.length > 1) {
    logger.warn(`Multiple chats available for element ${element?.id}`, chats)
  }
  const chat = chats[0]

  const create = async () => {
    if (!(element && editor)) {
      return
    }
    /** The element needs an ID. Generate it if it does not exist. Set comments hint. */
    const id = element.id ?? shortUuid()
    const updatedNode: CoreElement = { ...element, id, comments: true }
    const path = ReactEditor.findPath(editor as unknown as ReactEditor, element)
    Transforms.setNodes(editor, updatedNode, { at: path })

    /** Now create the chat */
    const chat = createChat({ ...element, id } as never)
    return chat
  }

  return {
    chat,
    chatLoading,
    create,
  }
}
